import styled from 'styled-components';
import { motion } from 'framer-motion';

export const AboutWrapper = styled.div`
  max-width: 1200px;
  margin: 4rem auto;
  padding: 0 2rem;
`;

export const AboutContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: start;
  margin-bottom: 4rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`;

export const ProfileSection = styled(motion.div)`
  position: relative;
  
  &:after {
    content: '';
    position: absolute;
    top: 20px;
    right: 20px;
    width: 100%;
    height: 100%;
    background: #2F4F4F;
    z-index: -1;
    border-radius: 10px;
  }
`;

export const ProfileImage = styled.img`
  width: 100%;
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  position: relative;
`;

export const AboutTitle = styled.h1`
  color: #2F4F4F;
  font-size: 2.5rem;
  margin-bottom: 1rem;
  text-align: center;
  position: relative;
  
  &:after {
    content: '';
    position: absolute;
    bottom: -10px;
    right: 50%;
    transform: translateX(50%);
    width: 100px;
    height: 3px;
    background: #2F4F4F;
  }
`;

export const AboutDescription = styled(motion.div)`
  color: #333;
`;

export const AboutText = styled.p`
  font-size: 1.1rem;
  line-height: 1.8;
  margin-bottom: 1.5rem;
`;

export const Stats = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  margin: 3rem 0;
`;

export const StatItem = styled.div`
  background: rgba(47, 79, 79, 0.05);
  padding: 1.5rem;
  border-radius: 10px;
  text-align: center;
`;

export const StatNumber = styled.div`
  color: #2F4F4F;
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
`;

export const StatLabel = styled.div`
  color: #666;
  font-size: 0.9rem;
`; 